import { Box } from '@mui/material';
import { useSelector } from 'react-redux';

import './Logo.scss';
import { Link } from 'react-router-dom';

const Logo = () => {
  const retailer = useSelector(state => state.retailer);
  
  return (
    <Box
      className="logo_info"
      sx={{}}
    >
      <Link to="/">
        <img
          src={`${process.env.REACT_APP_API_URL}/assets/${retailer.logo}?key=system-medium-contain`}
          alt="img"
          className="logo_img"
          style={{zIndex: 1, position: "relative"}}
        />
      </Link>
    </Box>
  );
};

export default Logo;
